<template>
  <div id="container"></div>
</template>

<script>
import * as THREE from "three";
import { Camera, PerspectiveCamera } from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
// export default {
//   data() {
//     return {
//       camera: null,
//       scene: null,
//       renderer: null,
//       mesh: null,
//     };
//   },
//   created() {
//     setTimeout(() => {
//       this.init();
//       //this.animate();
//     }, 2000);
//   },
//   mounted(){
     
//   },
//   methods: {
//     init() {
//       let container = document.getElementById("container");
//       this.camera = new Three.PerspectiveCamera(
//         60,
//         container.clientWidth / container.clientHeight,
//         0.2,
//         10000
//       );
//       this.camera.position.z = 0.5;
//       this.scene = new Three.Scene(); //创建一个场景
//       let geometry = new Three.BoxGeometry(0.2, 0.2, 0.2); //设置一个0.2宽度的正方形
//       let material = new Three.MeshNormalMaterial({ color: 0x0000ff }); //创建一个材质对象
//       this.mesh = new Three.Mesh(geometry, material); //网格模型对象Mesh
//       this.mesh.rotation.x += 10;
//        this.mesh.rotation.y += 10;
//       this.scene.add(this.mesh);

//       this.renderer = new Three.WebGLRenderer({ antialias: true });
//       this.renderer.setSize(container.clientWidth, container.clientHeight);
//       container.appendChild(this.renderer.domElement);
//       this.renderer.domElement.addEventListener("click",this.mouseclick(),false); //监听鼠标、键盘事件
//       this.render()
//     },
//     render() {
    
//       this.renderer.render(this.scene, this.camera);
//        let controls= new OrbitControls(this.camera, this.renderer.domElement)
     
//        requestAnimationFrame(this.render); //重新请求render
//     },
//     mouseclick(){
//       console.log('213123')
//     },
//     //动画事件
//     animate: function () {
//       requestAnimationFrame(this.animate);
//       this.mesh.rotation.x += 0.01;
//       this.mesh.rotation.y += 0.02;
//       this.renderer.render(this.scene, this.camera);
//     },
//   },
// };
export default {
  data () {
    return {
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      controls: null
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化
    init () {
      this.createScene() // 创建场景
      this.createMesh() // 创建网格模型
      this.createLight() // 创建光源
      this.createCamera() // 创建相机
      this.createRender() // 创建渲染器
      this.createControls() // 创建控件对象
      this.render() // 渲染
    },
    // 创建场景
    createScene () {
      this.scene = new THREE.Scene()
    },
    // 创建网格模型
    createMesh () {
      const geometry = new THREE.SphereGeometry(120, 120, 120) // 创建一个立方体几何对象Geometry
      const material = new THREE.MeshLambertMaterial({
        color: 0xe1e1e1
      }) // 材质对象Material
      console.log(material)
      this.mesh = new THREE.Mesh(geometry, material) // 网格模型对象Mesh
      this.scene.add(this.mesh) // 网格模型添加到场景中

    },
    // 创建光源
    createLight () {
      // 点光源
      const point = new THREE.PointLight(0xffffff)
      point.position.set(300, 200, 300) // 点光源位置
      this.scene.add(point) // 点光源添加到场景中
      // 环境光
      const ambient = new THREE.AmbientLight(0x66666)
      this.scene.add(ambient)
    },
    // 创建相机
    createCamera () {
      const element = document.getElementById('container')
      const width = element.clientWidth // 窗口宽度
      const height = element.clientHeight // 窗口高度
      const k = width / height // 窗口宽高比
      const s = 200 // 三维场景显示范围控制系数，系数越大，显示的范围越大
      // OrthographicCamera(left, right, top, bottom, near, far)
      this.camera = new THREE.OrthographicCamera(-s * k, s * k, s, -s, 1, 3000)
      this.camera.position.set(200, 300, 200) // 设置相机位置
      this.camera.lookAt(this.scene.position) // 设置相机方向
    },
    // 创建渲染器
    createRender () {
     
      const element = document.getElementById('container')
      this.renderer = new THREE.WebGLRenderer()
      this.renderer.setSize(element.clientWidth, element.clientHeight) // 设置渲染区域尺寸
      this.renderer.setClearColor(0x3f3f3f, 1) // 设置背景颜色
      element.appendChild(this.renderer.domElement)
    },
    render () {
      this.renderer.render(this.scene, this.camera)
      // 通过requestAnimationFrame实现周期性调用render
      
      requestAnimationFrame(this.render)
    },
    // 创建控件对象
    createControls () {
      this.controls = new OrbitControls(this.camera, this.renderer.domElement)
    }
  }
}
</script>

<style>
#container {
  height: 400px;
}
</style>